import { useContext } from 'react';

import { GrantType } from '@atom/types/policy';

import BudgetingApprovalTemplateSelection from './Budgeting/BudgetingApprovalTemplateSelection';
import BudgetingSelection from './Budgeting/BudgetingSelection';
import BudgetingTemplateSelection from './Budgeting/BudgetingTemplateSelection';
import BudgetingUnitTemplateSelection from './Budgeting/BudgetingUnitTemplateSelection';
import PolicyGenericGrantsSelection from './PolicyGenericGrantsSelection';
import PolicyModalContext from './PolicyModalContext';
import PolicySchemaSelection from './PolicySchemaSelection';
import PolicyUserSelection from './PolicyUserSelection';

import classes from './policyModals.module.css';

const PolicyGrantsSelection = () => {
  const {
    state: { grantType },
  } = useContext(PolicyModalContext);

  if (!grantType) {
    return null;
  }

  switch (grantType) {
    case GrantType.BUDGETING_BUDGET: {
      return (
        <div className={classes.inputContainer}>
          <BudgetingSelection />
        </div>
      );
    }
    case GrantType.BUDGETING_TEMPLATE: {
      return (
        <div className={classes.inputContainer}>
          <BudgetingTemplateSelection />
        </div>
      );
    }
    case GrantType.BUDGETING_UNIT: {
      return (
        <div className={classes.inputContainer}>
          <BudgetingUnitTemplateSelection />
        </div>
      );
    }
    case GrantType.BUDGETING_APPROVAL: {
      return (
        <div className={classes.inputContainer}>
          <BudgetingApprovalTemplateSelection />
        </div>
      );
    }
    case GrantType.INVENTORY_TYPE: {
      return (
        <div className={classes.inputContainer}>
          <PolicySchemaSelection />
        </div>
      );
    }
    case GrantType.USER: {
      return (
        <div className={classes.inputContainer}>
          <PolicyUserSelection />
        </div>
      );
    }
    case GrantType.WORK_LIST: {
      return <></>;
    }
    default:
      return <PolicyGenericGrantsSelection />;
  }
};

export default PolicyGrantsSelection;
